import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Makes a photo the active organization view's header image, or clears it.
const StoryHeaderToggle = (props) => {
    const title = props.disabled
        ? 'Save first to use this as a header'
        : props.isHeader ? `Header image for "${props.storyTitle}"` : `Use as header image for "${props.storyTitle}"`;
    return _jsx(_Fragment, { children: _jsxs("button", { type: "button", className: `btn btn-sm text-nowrap ${props.isHeader ? 'btn-success' : 'btn-outline-primary'}`, "aria-pressed": props.isHeader, disabled: props.disabled, title: title, onClick: props.onSelect, children: [_jsx("i", { className: `bi ${props.isHeader ? 'bi-image-fill' : 'bi-image'} me-1`, "aria-hidden": "true" }), "Header"] }) });
};
export default StoryHeaderToggle;
